import { createAsyncThunk } from "@reduxjs/toolkit";
import { HttpService } from "../../modules/shared/services/http.service";
import {
  Announcement,
  CreateAnnouncementData,
  UpdateAnnouncementData,
  AnnouncementFilters,
  AnnouncementResponse
} from "../../modules/shared/model/AnnouncementInterfaces";

// Get all announcements with pagination, sorting, and filtering
export const getAllAnnouncements = createAsyncThunk(
  "announcement/getAllAnnouncements",
  async (filters: AnnouncementFilters, { rejectWithValue }) => {
    try {
      const {
        page = 1,
        limit = 10,
        search = "",
        sortBy = "createdAt",
        sortOrder = "desc",
        type = "",
        priority = "",
        visibility = "",
        status = "",
        isShowLoader = true
      } = filters;

      let endpoint = `api/v1/announcements?page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
      
      if (search) {
        endpoint += `&search=${encodeURIComponent(search)}`;
      }
      if (type) {
        endpoint += `&type=${type}`;
      }
      if (priority) {
        endpoint += `&priority=${priority}`;
      }
      if (visibility) {
        endpoint += `&visibility=${visibility}`;
      }
      if (status) {
        endpoint += `&status=${status}`;
      }

      const response = await HttpService.get(endpoint, isShowLoader, { "Content-Type": "application/json" });
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch announcements");
    }
  }
);

// Get announcement by ID
export const getAnnouncementById = createAsyncThunk(
  "announcement/getAnnouncementById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await HttpService.get(`api/v1/announcements/${id}`, true, { "Content-Type": "application/json" });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch announcement");
    }
  }
);

// Create new announcement
export const createAnnouncement = createAsyncThunk(
  "announcement/createAnnouncement",
  async (data: CreateAnnouncementData, { rejectWithValue }) => {
    try {
      const response = await HttpService.post("api/v1/announcements", data, { "Content-Type": "application/json" }, true);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to create announcement");
    }
  }
);

// Update announcement
export const updateAnnouncement = createAsyncThunk(
  "announcement/updateAnnouncement",
  async ({ id, data }: { id: string; data: UpdateAnnouncementData }, { rejectWithValue }) => {
    try {
      const response = await HttpService.patch(`api/v1/announcements/${id}`, data, { "Content-Type": "application/json" }, true);
      console.log("🔍 Update API response:", response);
      return response.data || response;
    } catch (error: any) {
      console.error("🔍 Update API error:", error);
      return rejectWithValue(error.response?.data?.message || "Failed to update announcement");
    }
  }
);

// Delete announcement
export const deleteAnnouncement = createAsyncThunk(
  "announcement/deleteAnnouncement",
  async (id: string, { rejectWithValue }) => {
    try {
      await HttpService.deleteRecord(`api/v1/announcements/${id}`, { "Content-Type": "application/json" }, true);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete announcement");
    }
  }
);
